import { render, staticRenderFns } from "./recipe-cna-notice.vue?vue&type=template&id=93d9a7a0&scoped=true&"
import script from "./recipe-cna-notice.vue?vue&type=script&lang=js&"
export * from "./recipe-cna-notice.vue?vue&type=script&lang=js&"
import style0 from "./recipe-cna-notice.vue?vue&type=style&index=0&id=93d9a7a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93d9a7a0",
  null
  
)

export default component.exports